import React from "react";
import { Box, Button } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Langs from "../../../../../app/lang/langs";
import { ORANGE } from "../constants";

const barSx = {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  display: "flex",
  gap: 1.5,
  px: 2.5,
  pt: 2,
  // The bar is pinned to the bottom edge, so on a notched phone the buttons would
  // otherwise sit under the home indicator.
  pb: "calc(16px + env(safe-area-inset-bottom, 0px))",
  bgcolor: "rgba(255,255,255,0.95)",
  backdropFilter: "blur(16px)",
  borderTop: "1px solid rgba(0,0,0,0.06)",
  zIndex: 1400,
};

const cancelBtnSx = {
  borderRadius: 999,
  minHeight: 48,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  borderColor: "rgba(0,0,0,0.15)",
  color: "text.primary",
  "&:hover": { borderColor: "rgba(0,0,0,0.3)" },
  "&:active": { transform: "scale(0.97)" },
};

const deleteBtnSx = {
  borderRadius: 999,
  minHeight: 48,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  borderColor: "error.main",
  color: "error.main",
  "&:hover": { bgcolor: "error.main", color: "white", borderColor: "error.main" },
  "&:active": { transform: "scale(0.97)" },
};

const primaryBtnSx = {
  borderRadius: 999,
  minHeight: 48,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  bgcolor: ORANGE,
  boxShadow: "0 4px 14px rgba(255,144,21,0.4)",
  "&:hover": { bgcolor: "#e6820d", boxShadow: "0 6px 20px rgba(255,144,21,0.5)" },
  "&:active": { transform: "scale(0.97)" },
};

export default function BottomBar({ showEditButtons, showAddButtons, onHide, onSave, onAdd, onDelete }) {
  if (showEditButtons) {
    return (
      // Three buttons side by side put Delete a thumb-width from Save, and squeezed each
      // label to ~95px on a 360px screen. Delete gets its own row instead, so a mis-tap
      // on the primary action can no longer destroy the shift.
      <Box sx={{ ...barSx, flexDirection: "column", gap: 1.25 }}>
        <Box sx={{ display: "flex", gap: 1.5, width: "100%" }}>
          <Button variant="outlined" fullWidth onClick={onHide} sx={cancelBtnSx}>
            <Langs str="CANCEL" />
          </Button>
          <Button variant="contained" fullWidth onClick={onSave} sx={primaryBtnSx}>
            <Langs str="SAVE" />
          </Button>
        </Box>
        <Button variant="outlined" fullWidth onClick={onDelete} startIcon={<DeleteOutlineIcon />} sx={deleteBtnSx}>
          <Langs str="DELETE" />
        </Button>
      </Box>
    );
  }

  if (showAddButtons) {
    return (
      <Box sx={barSx}>
        <Button variant="outlined" fullWidth onClick={onHide} sx={cancelBtnSx}>
          <Langs str="CANCEL" />
        </Button>
        <Button variant="contained" fullWidth onClick={onAdd} sx={primaryBtnSx}>
          <Langs str="ADD" />
        </Button>
      </Box>
    );
  }

  return null;
}
